import { createFileRoute } from '@tanstack/react-router';

import { LuminovoApiPage } from '@/areas/settings/Settings/LuminovoApiPage/LuminovoApiPage';
import { canViewOtherOrganizationSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/api-integration')({
    staticData: {
        access: { permissions: canViewOtherOrganizationSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <LuminovoApiPage />;
}
